<div class="mb-3 d-flex" fxFlex fxLayoutAlign="end start">
  <button mat-button routerLink="/general-correspondence">
    <mat-icon>west</mat-icon>
  </button>
  <span ng-view flex layout-fill style="width: 90%"></span>
  <button matButton="outlined" color="warn" (click)="onClose()" [disabled]="generalCorrespondence.closed" *ngIf="canClose()">
    {{ 'UI.GENERAL_CORRESPONDENCE.CLOSE' | translate }}
  </button>
</div>

<div class="mb-3">
  <mat-card appearance="outlined">
    <mat-card-content>
      <div>
         <p><b>{{ ('UI.SUBJECT' | translate) + ': ' }} </b> {{ generalCorrespondence.subject }}</p>
         <p><b>{{ ('UI.SENT_BY' | translate) + ': ' }} </b> {{ generalCorrespondence.sentByGroup.formattedName }}</p>
         <p><b>{{ ('UI.RECEIVED_BY' | translate) + ': ' }} </b> {{ generalCorrespondence.receivingGroup?.formattedName }}</p>
         <p><b>{{ ('UI.RECEIVING_COUNTRY' | translate) + ': ' }} </b> {{ 'COUNTRY.' + generalCorrespondence.receivingCountryCode | translate }}</p>
         <p> <b>{{ ('UI.CREATED' | translate) + ': ' }} </b> {{ generalCorrespondence.createdAt | date: 'yyyy-MM-dd HH:mm z' }}</p>
        <p *ngIf="generalCorrespondence.lastResponseAt" role="listitem">
          <b>{{ ('UI.GENERAL_CORRESPONDENCE.LAST_RESPONSE' | translate) + ': ' }} </b>
          {{ generalCorrespondence.lastResponseAt | date: 'yyyy-MM-dd HH:mm z' }}
        </p>
      </div>
      <mat-list *ngIf="showAttachments(generalCorrespondence)" role="link">
        <mat-list-item>
          <b>{{ ('UI.GENERAL_CORRESPONDENCE.ATTACHMENTS' | translate) + ': ' }} </b>
        </mat-list-item>
        <mat-list-item role="listitem" *ngFor="let attachment of generalCorrespondence.attachments">
          <button mat-stroked-button color="primary" class="file-btn" (click)="onDownloadFile(attachment)">
            <mat-icon>attach_file</mat-icon> {{ attachment.fileName }} {{ attachment.sizeInKiloBytes }} Kb
          </button>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </mat-card>
  <br />
  <mat-card appearance="outlined">
   <mat-card-header>
      <mat-card-title>{{ ('UI.MESSAGE' | translate) + ': ' }}</mat-card-title>
      </mat-card-header>
    <mat-card-content>
      {{ generalCorrespondence.body }}
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-flat-button color="primary" class="me-2" (click)="onReply()" [disabled]="generalCorrespondence.closed">
        <mat-icon>reply</mat-icon> {{ 'UI.REPLY' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>

<div class="p-3 h-50 overflow-auto shadow" >
  <div class="mb-3" *ngFor="let reply of generalCorrespondenceReplies">
    <div class="w-50 p-3" >
      <p [class.current-user-color]="isReplyFromUser(reply)">{{ getReplyAuthor(reply) }}</p>
      <p>{{ 'Sent on: ' + (reply.createdAt | date: 'yyyy-MM-dd HH:mm z') }}</p>
      <mat-card appearance="outlined">
        <mat-card-content>
          {{ reply.body }}
        </mat-card-content>
      </mat-card>
      <mat-list role="link">
        <mat-list-item role="listitem" class="px-0" *ngFor="let attachment of reply.attachments">
          <button mat-stroked-button color="primary" class="file-btn" (click)="onDownloadFile(attachment)">
            <mat-icon>attach_file</mat-icon> {{ attachment.fileName }} {{ attachment.sizeInKiloBytes }} Kb
          </button>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</div>

  <mat-paginator
    [hidePageSize]="false"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="collatePaginateQueryDto.pageIndex"
    [pageSize]="collatePaginateQueryDto.pageSize"
    [length]="getTotalItems"
    (page)="selectedPage($event)"
  ></mat-paginator>
